var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',[_c('div',{staticClass:"index"},[_c('div',{staticClass:"title"},[_vm._v("Travy")]),_c('div',{staticClass:"desc"},[_vm._v("Frontend documentation")])])])}
var staticRenderFns = []

export { render, staticRenderFns }